import { Grid } from "@mui/material";
import { useEffect } from "react";
import DesignThinkingCardImg from "../../components/UmmIApps/Cards/DesignThinkingCardImg.png";
import GetAsignaturas from "../../data/GetAsignaturas";
import GetNiveles from "../../data/GetNiveles";
import AdaptacionesCurriculares from "../../components/Form/Fields/AdaptacionesCurriculares";
import Caracterizacion from "../../components/Form/Fields/Caracterizacion";
import CondicionesContexto from "../../components/Form/Fields/CondicionesContexto";
import DuracionHorasSemanaUmmIApps from "../../components/Form/Fields/DuracionHorasSemanasUmmIApps";
import DuracionSemanasUmmIApps from "../../components/Form/Fields/DuracionSemanasUmmIApps";
import TemaProblema from "../../components/Form/Fields/TemaProblema";
import GetObjetivosAprendizaje from "../../components/ObjetivosAprendizaje/GetObjetivosAprendizaje";
import { useActividadesContext } from "../../components/UmmIACategories/Hook/useActividades";
import UmmiaAppsLayout from "../../components/UmmIACategories/Layout/UmmiaAppsLayout";

const DesignThinkingPage = () => {
  const {
    materiaId,
    nivelId,
    promptData,
    handleBack,
    setTextoInicial,
    isOAAdded,
    handleNivelChange,
    handleAsignaturaChangeLocal,
    handleInitialPromptData,
  } = useActividadesContext();

  //Variable para condicionar la habilitación del botón "Generar"
  const isButtonDisabled = !(
    promptData.nivel &&
    promptData.materia &&
    promptData.tema_problematica &&
    promptData.horas_semanales &&
    promptData.cantidad_de_semanas &&
    isOAAdded
  );
  const colorIconBack = "#278C62";

  useEffect(() => {
    const init = {
      nivel: "",
      objetivos: [],
      materia: "",
      tema_problematica: "",
      caracterizacion: "",
      condiciones_contexto: "",
      adaptaciones_curriculares: "",
      horas_semanales: 12,
      cantidad_de_semanas: 8,
    };
    handleInitialPromptData(init, "design_thinking");
    setTextoInicial(
      "Esta es la propuesta que tengo para ti.  Puedes revisar y modificar cualquier parte según tus necesidades. Ajusta los parámetros en 'Mostrar campos', genera una nueva versión con 'Volver a generar' o personaliza el contenido con 'Editar'. Si prefieres trabajar en otra plataforma, usa 'Copiar' para llevar el texto donde desees."
    );
  }, []);

  return (
    <>
      <UmmiaAppsLayout
        onBack={handleBack}
        imageSrc={DesignThinkingCardImg}
        backgroundColorImage={
          "linear-gradient(180deg, #FFFFFF 0%, #A9D1C0 100%, #52A381 100%)"
        }
        titleColor="#278C62"
        title="Pensamiento de diseño (Design Thinking)"
        description="Crea experiencias de aprendizaje innovadoras con la metodología Pensamiento de Diseño, potenciando la capacidad de tus estudiantes para resolver problemas de forma efectiva y creativa."
        isButtonDisabled={isButtonDisabled}
        colorIconBack={colorIconBack}
      >
        <Grid item xs={12} lg={12} display="flex" flexDirection="row">
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mr: 2, mb: 4 }}>
            <GetNiveles
              onNivelChange={handleNivelChange}
              selectedNivel={nivelId}
            />
          </Grid>

          {/* Nuevo componente para consultar y probar el endpoint de asignaturas */}
          <Grid item xs={12} sm={6} md={6} lg={12} sx={{ mb: 4 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={handleAsignaturaChangeLocal}
              selectedAsignatura={materiaId}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12} lg={12}>
          <GetObjetivosAprendizaje
            nombreAsignatura={promptData.materia}
            nombreNivel={promptData.nivel}
          />
        </Grid>

        <Grid
          item
          xs={12}
          lg={12}
          md={12}
          display={"flex"}
          flexDirection={"row"}
        >
          <TemaProblema />
        </Grid>

        <Grid item xs={12} md={6}>
          <DuracionSemanasUmmIApps />
        </Grid>

        <Grid item xs={12} md={6}>
          <DuracionHorasSemanaUmmIApps />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <CondicionesContexto />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <Caracterizacion />
        </Grid>

        <Grid item xs={12} lg={12} display={"flex"} flexDirection={"row"}>
          <AdaptacionesCurriculares />
        </Grid>
      </UmmiaAppsLayout>
    </>
  );
};

export default DesignThinkingPage;
